import { getBuildVersion } from '../service/buildInfo.js';

const STORAGE_KEY = 'nettgrav:build_version';

const encode = (value) =>
  typeof value === 'string' && value.trim() ? encodeURIComponent(value.trim()) : null;

export const getMlsEntryCacheBustQuery = () => {
  if (typeof window === 'undefined' || !window?.localStorage) {
    return null;
  }

  const version = getBuildVersion();
  const encodedVersion = encode(version);

  if (!encodedVersion) {
    return null;
  }

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    const hasChanged = stored && stored !== version;

    window.localStorage.setItem(STORAGE_KEY, version);

    return hasChanged ? `mls-bust=${encodedVersion}` : null;
  } catch {
    return null;
  }
};

